import { render } from "./FeaturedMatchListContent.vue?vue&type=template&id=701289ff&scoped=true"
import script from "./FeaturedMatchListContent.vue?vue&type=script&lang=js"
export * from "./FeaturedMatchListContent.vue?vue&type=script&lang=js"

import "./FeaturedMatchListContent.vue?vue&type=style&index=0&id=701289ff&scoped=true&lang=css"
import "./FeaturedMatchListContent.vue?vue&type=style&index=1&id=701289ff&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701289ff"]])

export default __exports__